var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-input-textarea"},[_vm._t("default"),_c('textarea',_vm._b({attrs:{"rows":"5"},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'textarea',_vm.$attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }